import { useTypedDispatch, useTypedSelector } from "@/redux/helpers/hooks";
import { ICartItemProps } from "../../cartInterface";
import useCurrency from "@/lib/helpers/hooks/useCurrency";
import * as S from "../styles.ts";
import { Button, LoadingSpinner } from "@/template/components";
import { deleteCartItem } from "@/redux/slices/user/thunks/deleteCartItem";
import { Trash2 } from "@/template/icons";
import { AnimatePresence, motion } from "framer-motion";

export const CartItem = ({ item, billing_interval }: ICartItemProps) => {
  const dispatch = useTypedDispatch();
  const currency = useCurrency();
  const { user } = useTypedSelector((state) => state.user);

  const { loading } = item;

  let billingLabel = "";

  if (
    item.cost_net !== 0 &&
    item.is_recurring &&
    item.type.name !== "Domain Name"
  ) {
    billingLabel = billing_interval === "monthly" ? "p/m" : "p/yr";
  }

  return (
    <S.CartItemWrapper
      as={motion.div}
      animate={{
        height: "auto",
        opacity: 1,
      }}
      exit={{
        height: 0,
        opacity: 0,
      }}
    >
      <S.CartItemContainer tabIndex={0}>
        <S.InlineContainer>
          <S.CartItemLabel>
            <Button
              size="xs"
              variant="light"
              isIcon
              onClick={(e) => {
                e.stopPropagation();
                if (loading) return;
                dispatch(deleteCartItem(item.id));
              }}
            >
              <Trash2 fontSize={16} />
            </Button>
            {item?.type?.name === "VoIP Plan Change"
              ? `${item?.description?.split(" ").slice(0, 3).join(" ")} Plan`
              : item.name}
          </S.CartItemLabel>
          <AnimatePresence>
            <S.CartItemPrice>
              {loading ? (
                <LoadingSpinner width={20} />
              ) : (
                <>
                  {item.cost_net === 0 && !user?.has_voip
                    ? "FREE"
                    : `${currency}${(item.cost_net / 100).toFixed(2)}`}
                  {billingLabel && <span>{billingLabel}</span>}
                </>
              )}
            </S.CartItemPrice>
          </AnimatePresence>
        </S.InlineContainer>
      </S.CartItemContainer>
    </S.CartItemWrapper>
  );
};

export default CartItem;
